export class Microsoft365SharePointSite {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "siteId",
            "baseName": "siteId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "webUrl",
            "baseName": "webUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365SharePointSite.attributeTypeMap;
    }
    constructor() {
    }
}
